import 'antd/dist/reset.css';
import './App.css'; 
import './SearchBox.css'; 
import './CustomTable.css'; 
import './Queries.css'; 
import './About.css'; 
import './Requirements.css'; 
import './Workflow.css'; 
import './Availables.css'; 
import './Reports.css'; 

import { Routes, Route, Link, useNavigate, useLocation, Navigate } from 'react-router-dom';


import { MenuOutlined } from '@ant-design/icons';
import Cookies from "js-cookie";



import SearchComponent from './Components/SearchComponent';
import CreateUserComponent from './Components/CreateUserComponent';
import LoginUserComponent from './Components/LoginUserComponent';
import RequirementsComponent from './Components/RequirementsComponent';
import WorkflowComponent from './Components/WorkflowComponent';
import DashboardComponent from './Components/DashboardComponent';
import AboutComponent from './Components/AboutComponent';
import NewsComponent from './Components/NewsComponent';  // 🔹 Importa NewsComponent

import { Layout, Menu, Row, Col, Button, Drawer  } from 'antd';
import { useEffect, useState } from 'react';
import AvailablesComponent from './Components/AvailablesComponent';
import AssignedComponent from './Components/AssignedComponent';
import ReportsComponent from './Components/ReportsComponent';
import QueriesComponent from './Components/QueriesComponent';
import AddComponent from './Components/AddComponent';
import ApprovedComponent from './Components/ApprovedComponent';

import React from 'react';
import { notification } from 'antd';
import { backendURL } from './Globals';

// 🔹 Carga de imágenes desde la carpeta assets/logos
const buo = `${process.env.PUBLIC_URL}/assets/logos/buo.png`;
const unioviblanco = `${process.env.PUBLIC_URL}/assets/logos/unioviblanco.png`;

let App = () => {
  const [api, contextHolder] = notification.useNotification();
  let [login, setLogin] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  let navigate = useNavigate();
  let location = useLocation();
  let { Header, Content, Footer } = Layout;

  useEffect(() => {
    checkLogin();
  }, []);

  let checkLogin = async () => {
    if (localStorage.getItem("apiKey") != null) {
      let response = await fetch(backendURL + "/users/checklogin?apiKey=" + localStorage.getItem("apiKey"));
      if (response.status === 401) {
        setLogin(false);
  
        // 🚀 Solo redirige a login si el usuario está en una ruta protegida
        if (location.pathname.startsWith("/assigned") || 
            location.pathname.startsWith("/dashboards") || 
            location.pathname.startsWith("/add") || 
            location.pathname.startsWith("/approved")) {
          navigate("/login");
        }
      } else {
        setLogin(true);
      }
    } else {
      setLogin(false);
    }
  };
  

  let createNotification = (type = "error", msg, placement = "top") => {
    api[type]({
      message: msg,
      description: msg,
      placement
    });
  };

  const handleLogout = async () => {
    const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");

    if (!apiKey) return;

    try {
        // Ahora usamos POST en lugar de GET y pasamos la API Key en los headers
        await fetch(`${backendURL}/users/logout`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${apiKey}`, // 🔹 Ahora se envía en los headers
            },
        });
    } catch (error) {
        console.error("Error al cerrar sesión:", error);
    }

    // 🔹 Limpiar el almacenamiento local
    Cookies.remove("apiKey");
    localStorage.removeItem("apiKey");

    // 🔹 Notificar a los demás componentes para actualizar su estado
    window.dispatchEvent(new Event("storage"));

    // 🔹 Actualizar el estado de autenticación si usas `setLogin`
    if (setLogin) {
        setLogin(false);
    }

    // 🔹 Redirigir al usuario a la página "/about" tras cerrar sesión
    navigate("/about");
};

  const getMenuKey = () => {
    if (location.pathname === "/" || location.pathname.startsWith("/about")) return "menuAbout";
    if (location.pathname.startsWith("/requeriments")) return "menuRequeriments";
    if (location.pathname.startsWith("/search")) return "Menusearch";
    if (location.pathname.startsWith("/workflow")) return "MenuWorflow";
    if (location.pathname.startsWith("/assigned")) return "MenuAssigned";
    if (location.pathname.startsWith("/dashboards")) return "MenuDashboard";
    if (location.pathname.startsWith("/availables")) return "MenuAvailables";
    if (location.pathname.startsWith("/reports")) return "MenuReports";
    if (location.pathname.startsWith("/add")) return "MenuAdd";
    if (location.pathname.startsWith("/approved")) return "MenuApproved";
    if (location.pathname.startsWith("/news")) return "MenuNews";  // 🔹 Nueva clave para menú
    return null;
  };

  return (
    <>
      {contextHolder}

      <meta name="viewport" content="width=device-width, initial-scale=1"></meta>

      <Layout style={{ minHeight: '100vh', backgroundColor: '#FFFFFF' }}>
        <Header className='barra-uniovi'>
          <h1 className="titulo">Acuerdos Transformativos</h1>
          <a href="https://www.uniovi.es/" target="_blank" rel="noopener noreferrer">
            <img style={{ paddingTop: '0.3cm', paddingLeft: '0.9cm' }} src={unioviblanco} className="uniovi-logo" alt="Logo UniOvi" />
          </a>
        </Header>

        <Header className="HeaderAnt">
  {window.location.pathname !== "/login" && (
    <div>
      {/* Menú para pantallas grandes */}
      <Row>
        <Col xs={0} sm={0} md={24}>
          <Menu
            className="HeaderAnt"
            style={{
              fontFamily: 'Yu Gothic Light',
              paddingTop: '0.1cm',
              fontSize: '18px',
              fontWeight: '900',
              paddingRight: '1cm'
            }}
            mode="horizontal"
            selectedKeys={[getMenuKey()]}
            items={[
              { key: "menuAbout", label: <Link to="/about">Información</Link> },
              { key: "menuNews", label: <Link to="/news">Novedades</Link> },
              { key: "menuRequeriments", label: <Link to="/requeriments">Requisitos</Link> },
              { key: "Menusearch", label: <Link to="/search">Buscador</Link> },
              { key: "MenuWorflow", label: <Link to="/workflow">Procedimiento</Link> },
              { key: "MenuAvailables", label: <Link to="/availables">Disponibles</Link> },
              { key: "MenuReports", label: <Link to="/reports">Estadísticas</Link> },
              !login && { key: "MenuQueries", label: <Link to="/queries">Contacta</Link> },
              login && { key: "MenuAssigned", label: <Link to="/assigned">Asignados</Link> },
              login && { key: "MenuDashboard", label: <Link to="/dashboards">Dashboards</Link> },
              login && { key: "MenuAdd", label: <Link to="/add">Añadir</Link> },
              login && { key: "MenuApproved", label: <Link to="/approved">Aprobados</Link> },
              login && { key: "MenuDisconect", label: <Link to="#" onClick={handleLogout}>Salir</Link> },
            ].filter(Boolean)}
          />
        </Col>

        {/* Botón hamburguesa para pantallas pequeñas */}
        <Col xs={24} sm={24} md={0} style={{ textAlign: 'right', padding: '0.5em' }}>
          <Button icon={<MenuOutlined />} onClick={() => setMenuOpen(true)} />
        </Col>
      </Row>

      {/* Menú desplegable para móviles */}
      <Drawer
        title="Menú"
        placement="right"
        closable
        onClose={() => setMenuOpen(false)}
        open={menuOpen}
      >
        <Menu
          mode="vertical"
          selectedKeys={[getMenuKey()]}
          onClick={() => setMenuOpen(false)}
          items={[
            { key: "menuAbout", label: <Link to="/about">Información</Link> },
            { key: "menuNews", label: <Link to="/news">Novedades</Link> },
            { key: "menuRequeriments", label: <Link to="/requeriments">Requisitos</Link> },
            { key: "Menusearch", label: <Link to="/search">Buscador</Link> },
            { key: "MenuWorflow", label: <Link to="/workflow">Procedimiento</Link> },
            { key: "MenuAvailables", label: <Link to="/availables">Disponibles</Link> },
            { key: "MenuReports", label: <Link to="/reports">Estadísticas</Link> },
            !login && { key: "MenuQueries", label: <Link to="/queries">Contacta</Link> },
            login && { key: "MenuAssigned", label: <Link to="/assigned">Asignados</Link> },
            login && { key: "MenuDashboard", label: <Link to="/dashboards">Dashboards</Link> },
            login && { key: "MenuAdd", label: <Link to="/add">Añadir</Link> },
            login && { key: "MenuApproved", label: <Link to="/approved">Aprobados</Link> },
            login && { key: "MenuDisconect", label: <Link to="#" onClick={handleLogout}>Salir</Link> },
          ].filter(Boolean)}
        />
      </Drawer>
    </div>
  )}
</Header>

        <Content style={{ textAlign: 'center', backgroundColor: '#FFFFFF' }}>
          <Routes>
              {/* Redirección automática de "/" a "/about" */}
    <Route path="/" element={<Navigate to="/about" replace />} />
            <Route path="/register" element={<CreateUserComponent />} />
            <Route path="/search" element={<SearchComponent />} />
            <Route path="/requeriments" element={<RequirementsComponent />} />
            <Route path="/workflow" element={<WorkflowComponent />} />
            <Route path="/dashboards" element={<DashboardComponent />} />
            <Route path="/about" element={<AboutComponent />} />
            <Route path="/news" element={<NewsComponent />} />  {/* 🔹 Nueva ruta */}
            <Route path="/assigned" element={<AssignedComponent />} />
            <Route path="/availables" element={<AvailablesComponent />} />
            <Route path="/reports" element={<ReportsComponent />} />
            <Route path="/queries" element={<QueriesComponent />} />
            <Route path="/add" element={<AddComponent />} />
            <Route path="/approved" element={<ApprovedComponent />} />
            <Route path="/login" element={<LoginUserComponent setLogin={setLogin} createNotification={createNotification} />} />
             
          </Routes>
        </Content>

        <Footer className='FooterAnt'>
          <hr className='hr-baja'></hr>
          <div className='FooterContent'>
            <img src={buo} alt="Logo Universidad de Oviedo" className='footer-logo' />
            <div className='footer-text'>
              <p>Subdirección Técnica, de Cooperación Bibliotecaria y Servicios a Distancia</p>
              <p>Copyright © {new Date().getFullYear()} Biblioteca de la Universidad de Oviedo</p>
            </div>
          </div>
        </Footer>
      </Layout>
    </>
  );
}

export default App;


